import { GridColDef } from "@mui/x-data-grid-pro";

// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

const columns: GridColDef[] = [
	{
		field: "_id",
		headerName: "ID",
		flex: 1,
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },

	{
		field: "manuallyReconciled",
		editable: true,
		headerName: "",
	},
	{
		headerName: "Lot/Address",
		field: "name",
		width: 100,
	},
	{
		headerName: "VIN",
		field: "vinNumber",
		width: 120,
	},
	{
		headerName: "Year",
		field: "year",
		width: 60,
	},
	{
		headerName: "",
		field: "_empty",
		width: 60,
	},
	{
		field: "make",
		width: 140,
		headerName: "Make",
	},
	{
		headerName: "Model",
		field: "model",
		width: 140,
	},
	{
		headerName: "Color",
		width: 110,
		field: "color",
	},
	{
		field: "reason",
		width: 140,
		headerName: "Reason",
		editable: true,
	},
	{
		field: "resolution",
		width: 140,
		headerName: "Resolution",
		editable: true,
	},
	{
		field: "notes",
		headerAlign: "right",
		headerName: "Notes",
		align: "right",
		width: 80,
		editable: true,
	},
];

type TOnLotNotScheduledTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

export default function OnLotNotScheduledTable(props: TOnLotNotScheduledTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;

	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onLotNotScheduled"
		/>
	);
}
